import { render } from "./FlashMessages.vue?vue&type=template&id=a1139c76"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Developer\\Desktop\\Company\\help-desk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__